// extracted by mini-css-extract-plugin
export default {"leftArrow":"slider_leftArrow__B3GSb","rightArrow":"slider_rightArrow__rtV9N"};